export const ARROW_DOWN = (
    <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9906 17.5953L19.293 11.2929L20.7072 12.7071L12.0001 21.4142L3.29297 12.7071L4.70718 11.2929L10.9906 17.5763L11.0001 2.99935L13.0001 3.00065L12.9906 17.5953Z"
    />
);
export const ARROW_LEFT = (
    <>
        <path d="M1 12h22" stroke="currentColor" strokeWidth="1.5" />
        <path
            d="m9 9-8 3 8 3"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="bevel"
        />
    </>
);
export const ARROW_RIGHT = (
    <>
        <path
            stroke="currentColor"
            d="M1 12h22"
            strokeWidth="1.5"
            fill="none"
        />
        <path
            fill="none"
            stroke="currentColor"
            d="m15 9 8 3-8 3"
            strokeWidth="1.5"
            strokeLinejoin="bevel"
        />
    </>
);
export const ARROW_UP = (
    <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7166 6.81894L4.41421 13.1213L3 11.7071L11.7071 3L20.4142 11.7071L19 13.1213L12.7166 6.83791L12.7071 21.4148L10.7071 21.4135L10.7166 6.81894Z"
    />
);
export const CHECK = (
    <path
        d="M21 5.5c-3.5 2.5-4 3-7 6S8 20 6.444 20.302c-1.557.3-2.118-4.886-3.475-8.016"
        strokeWidth="1.5"
    />
);
export const CHEVRON_DOWN = (
    <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 14.5858L19.2929 7.29289L20.7072 8.70711L12 17.4142L3.29294 8.70711L4.70715 7.29289L12 14.5858Z"
    />
);
export const CHEVRON_LEFT = (
    <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.41426 12L16.7072 19.2929L15.2929 20.7071L6.58583 12L15.2929 3.29289L16.7072 4.70711L9.41426 12Z"
    />
);
export const CHEVRON_RIGHT = (
    <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5857 12L7.29285 4.70711L8.70706 3.29289L17.4142 12L8.70706 20.7071L7.29285 19.2929L14.5857 12Z"
    />
);
export const CHEVRON_UP = (
    <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 9.41421L4.70706 16.7071L3.29285 15.2929L12 6.58579L20.7071 15.2929L19.2928 16.7071L12 9.41421Z"
    />
);
export const CLOSE = (
    <path
        stroke="var(--color-beige-40)"
        strokeLinejoin="bevel"
        strokeWidth="1.5"
        d="M13.667 1.333.333 6M.333 1.333 13.666 6"
    />
);
export const CLOSE_WITH_TEXT = (
    <>
        <path
            stroke="var(--color-brown-50)"
            strokeLinejoin="bevel"
            strokeWidth="1.5"
            d="m2 5 14 4.9M22 5 2 12"
        />
        <path
            fill="var(--color-brown-50)"
            d="M3.955 20.584c-.317.112-.605.144-.865.096a.934.934 0 0 1-.607-.394c-.15-.213-.224-.509-.224-.887v-.098c0-.378.075-.726.224-1.045a2.564 2.564 0 0 1 1.472-1.34c.312-.11.58-.148.805-.11a.882.882 0 0 1 .54.291c.142.15.234.347.278.588l-.805.467a.764.764 0 0 0-.119-.336.412.412 0 0 0-.264-.172c-.11-.027-.248-.01-.415.049a1.328 1.328 0 0 0-.772.735 1.5 1.5 0 0 0-.113.593v.07c0 .22.038.393.113.52.079.121.184.198.316.231.137.026.288.01.456-.05.25-.088.44-.223.567-.403.132-.187.216-.398.25-.635l.806-.082a2.854 2.854 0 0 1-.297.784 2.442 2.442 0 0 1-.541.668c-.224.196-.493.35-.805.46ZM7.141 19.357v-4.9l.832-.294v4.9l-.832.294ZM11.31 17.98c-.326.115-.619.148-.878.1a.929.929 0 0 1-.614-.391c-.15-.213-.224-.507-.224-.88v-.112c0-.373.074-.72.224-1.038a2.617 2.617 0 0 1 1.491-1.347c.326-.116.618-.15.878-.101.26.048.464.178.614.391.15.213.224.507.224.88v.112c0 .373-.075.72-.225 1.038-.149.32-.354.595-.613.827-.26.232-.552.405-.878.52Zm0-.785c.254-.09.466-.251.633-.483.167-.236.25-.518.25-.845v-.07c0-.326-.083-.546-.25-.66-.163-.12-.374-.133-.634-.042-.255.09-.466.254-.633.49-.167.233-.25.512-.25.838v.07c0 .327.083.55.25.668.167.113.378.125.633.034ZM16.01 16.315c-.427.151-.777.177-1.05.077-.273-.099-.437-.32-.495-.664l.766-.481c.03.152.081.263.152.331a.42.42 0 0 0 .27.107 1.12 1.12 0 0 0 .356-.07c.194-.069.337-.154.43-.257a.496.496 0 0 0 .138-.322c0-.107-.044-.173-.132-.198-.088-.03-.229-.029-.422.002l-.185.03a2.949 2.949 0 0 1-.627.034.756.756 0 0 1-.455-.182c-.115-.104-.172-.27-.172-.5 0-.345.119-.65.357-.916.237-.271.55-.475.936-.612.366-.13.67-.15.911-.064.242.087.4.257.475.511l-.772.525c-.035-.164-.108-.265-.218-.3-.105-.038-.237-.028-.396.028a.89.89 0 0 0-.363.22.397.397 0 0 0-.125.282c0 .112.044.18.132.205.088.02.207.018.356-.007l.185-.03a3.22 3.22 0 0 1 .667-.048c.202.003.36.057.475.161.119.098.178.268.178.511 0 .364-.126.69-.376.98-.247.283-.579.499-.997.647ZM20.46 14.74c-.326.114-.614.144-.865.088a.948.948 0 0 1-.58-.417c-.137-.223-.205-.516-.205-.88v-.084a2.528 2.528 0 0 1 .779-1.843c.246-.237.532-.413.857-.528.321-.114.6-.136.838-.066.238.065.423.21.555.434.132.22.198.506.198.86v.302l-2.383.843c.01.235.093.4.251.492.159.094.352.1.58.019.234-.083.406-.197.516-.344.11-.146.193-.294.25-.445l.68.137a3.61 3.61 0 0 1-.27.495c-.115.18-.269.356-.462.527-.194.167-.44.303-.74.41Zm-.799-1.951 1.531-.542c-.018-.195-.095-.328-.231-.401-.132-.075-.306-.074-.521.002a1.147 1.147 0 0 0-.779.94Z"
        />
    </>
);
export const TWITTER = (
    <path d="M19.995 6.68799C20.8915 6.15208 21.5622 5.30823 21.882 4.31399C21.0397 4.81379 20.1181 5.16587 19.157 5.35499C17.8246 3.94552 15.7135 3.60251 14.0034 4.51765C12.2933 5.43278 11.4075 7.37948 11.841 9.26999C8.39062 9.09676 5.17598 7.46691 2.99702 4.78599C1.85986 6.74741 2.44097 9.25477 4.32502 10.516C3.64373 10.4941 2.97754 10.3096 2.38202 9.97799C2.38202 9.99599 2.38202 10.014 2.38202 10.032C2.38241 12.0751 3.82239 13.8351 5.82502 14.24C5.19308 14.4119 4.53022 14.4372 3.88702 14.314C4.45022 16.0613 6.06057 17.2583 7.89602 17.294C6.37585 18.4871 4.49849 19.1342 2.56602 19.131C2.22349 19.1315 1.88123 19.1118 1.54102 19.072C3.50341 20.333 5.78739 21.0023 8.12002 21C11.3653 21.0223 14.484 19.7429 16.7787 17.448C19.0734 15.1531 20.3526 12.0342 20.33 8.78899C20.33 8.60299 20.3257 8.41799 20.317 8.23399C21.1575 7.62659 21.8828 6.87414 22.459 6.01199C21.676 6.35905 20.8455 6.58691 19.995 6.68799Z" />
);
export const WHATSAPP = (
    <path
        xmlns="http://www.w3.org/2000/svg"
        d="M2.05 22l1.476-5.393c-.911-1.578-1.389-3.368-1.389-5.203C2.14 5.668 6.808 1 12.544 1a10.34 10.34 0 0 1 7.361 3.052c1.964 1.967 3.046 4.582 3.045 7.362-.003 5.737-4.671 10.406-10.406 10.406-1.741-.001-3.457-.437-4.977-1.267L2.05 22zm5.772-3.331c1.467.871 2.867 1.392 4.718 1.393a8.67 8.67 0 0 0 8.653-8.649 8.65 8.65 0 0 0-8.646-8.655c-4.77 0-8.651 3.88-8.653 8.649-.001 1.947.57 3.405 1.528 4.93l-.874 3.192 3.274-.858zm9.964-4.781c-.065-.108-.238-.173-.499-.304s-1.538-.76-1.777-.846-.411-.13-.585.13-.672.846-.823 1.019-.304.195-.563.065-1.098-.404-2.091-1.291c-.773-.69-1.295-1.541-1.446-1.802s-.016-.401.114-.53c.117-.116.26-.304.39-.456s.175-.259.262-.433.044-.325-.022-.456-.585-1.41-.801-1.93c-.212-.507-.426-.438-.585-.446L8.859 6.6c-.173 0-.455.065-.693.326s-.91.889-.91 2.169.932 2.516 1.061 2.69 1.833 2.8 4.442 3.926c.62.268 1.105.428 1.482.548.623.198 1.19.17 1.638.103.5-.074 1.538-.629 1.755-1.236s.217-1.129.151-1.237z"
    />
);
export const YOUTUBE = (
    <path d="M12.006 19.012H11.986C11.924 19.012 5.721 19 4.156 18.575C3.29543 18.3432 2.62335 17.6707 2.392 16.81C2.11058 15.2224 1.97469 13.6123 1.986 12C1.97873 10.385 2.11831 8.77271 2.403 7.183C2.64071 6.32151 3.30983 5.64595 4.169 5.4C5.691 5 11.723 5 11.979 5H12C12.063 5 18.282 5.012 19.831 5.437C20.6898 5.67001 21.3605 6.3411 21.593 7.2C21.8834 8.79354 22.0197 10.4113 22 12.031C22.007 13.644 21.8671 15.2543 21.582 16.842C21.3477 17.7016 20.6752 18.3726 19.815 18.605C18.295 19.008 12.262 19.012 12.006 19.012ZM10.006 9.005L10.001 15.005L15.213 12.005L10.006 9.005Z" />
);
export const STAR_FULL = (
    <path
        d="M12.4292 17.5836L12.934 17.029L12.416 16.5574L11.9102 17.0422L12.4292 17.5836ZM12.4292 17.5836L12.9341 17.029L12.9342 17.0291L12.935 17.0298L12.9383 17.0328L12.9517 17.045L13.0052 17.0934C13.0522 17.1359 13.1215 17.1983 13.2101 17.2777C13.3873 17.4365 13.6414 17.6628 13.9481 17.9319C14.5623 18.4709 15.3846 19.1792 16.222 19.8614C17.0644 20.5476 17.9026 21.1914 18.5536 21.6113C18.5658 21.6192 18.5779 21.627 18.5899 21.6346C18.5732 21.5843 18.5554 21.5321 18.5365 21.4781C18.2921 20.7777 17.9157 19.8931 17.519 18.9671C17.5018 18.927 17.4846 18.8869 17.4674 18.8467C17.0926 17.9723 16.706 17.0701 16.4309 16.3144C16.2872 15.9198 16.1655 15.5425 16.092 15.216C16.0553 15.0525 16.0268 14.8855 16.017 14.7253C16.0077 14.5739 16.0113 14.3771 16.0766 14.1804C16.1419 13.9833 16.2564 13.8239 16.3551 13.708C16.459 13.5861 16.5814 13.4711 16.7078 13.3646C16.9599 13.1521 17.2796 12.9303 17.6251 12.7088C18.1971 12.3421 18.9028 11.9371 19.6062 11.5333C19.7522 11.4495 19.8981 11.3657 20.0427 11.2824C20.9001 10.7882 21.7141 10.307 22.3169 9.87534C22.5129 9.73494 22.6752 9.60778 22.8036 9.49488C22.7657 9.48972 22.7252 9.48476 22.6821 9.48007C22.0727 9.4138 21.2138 9.4265 20.2654 9.458C20.0629 9.46472 19.8565 9.4723 19.6492 9.47991C18.9129 9.50693 18.164 9.53442 17.5304 9.52605C17.1235 9.52067 16.7335 9.50052 16.4046 9.44954C16.2397 9.42399 16.0718 9.388 15.9158 9.33413C15.7668 9.28269 15.5809 9.19896 15.4209 9.05158C15.2104 8.85757 15.0409 8.57145 14.9086 8.31878C14.7643 8.04329 14.616 7.71026 14.4674 7.35129C14.2246 6.7648 13.9637 6.06585 13.7029 5.36723C13.645 5.21237 13.5872 5.05753 13.5296 4.90393C13.2074 4.04462 12.8909 3.22223 12.5965 2.58668C12.5636 2.51569 12.5315 2.4481 12.5002 2.38397C12.3918 2.88583 12.2896 3.51389 12.1762 4.21039C12.1458 4.397 12.1147 4.58853 12.0824 4.78386C11.9145 5.79915 11.718 6.90126 11.449 7.80568C11.3145 8.2576 11.1531 8.69187 10.9508 9.05363C10.7565 9.40139 10.4738 9.77438 10.0526 9.97126C9.71244 10.1302 9.29851 10.1928 8.90521 10.218C8.49636 10.2443 8.0337 10.2341 7.55388 10.2045C6.66715 10.1499 5.65595 10.0243 4.71714 9.90771C4.64214 9.89839 4.56759 9.88914 4.49361 9.87998C3.70565 9.78243 2.99363 9.69781 2.42796 9.66177C2.50353 9.71703 2.5841 9.7743 2.6695 9.83351C3.29706 10.2686 4.10901 10.7564 4.94759 11.2568C4.99232 11.2835 5.03713 11.3102 5.082 11.337C5.86519 11.8042 6.66302 12.2801 7.29453 12.7072C7.62804 12.9328 7.93548 13.1582 8.17829 13.3735C8.3897 13.561 8.66844 13.8383 8.78185 14.1804C8.89738 14.529 8.83252 14.9226 8.77087 15.1981C8.69973 15.516 8.5811 15.8799 8.44136 16.2588C8.18433 16.9556 7.82535 17.7831 7.4716 18.5985C7.44041 18.6704 7.40925 18.7422 7.3782 18.8138C6.98883 19.7122 6.61627 20.583 6.36746 21.3009C6.30103 21.4926 6.24584 21.6666 6.20237 21.8219C6.22452 21.8085 6.24724 21.7946 6.27054 21.7801C6.90503 21.386 7.73894 20.7365 8.58801 20.0244C9.43004 19.3181 10.2609 18.5724 10.8828 18.0017C11.1933 17.7167 11.4509 17.4762 11.6305 17.3071C11.7203 17.2226 11.7906 17.1561 11.8382 17.1108L11.8924 17.0592L11.906 17.0462L11.9093 17.0431L11.91 17.0423L11.9102 17.0422L12.4292 17.5836ZM18.79 22.4675C18.7899 22.4675 18.79 22.4655 18.7904 22.4617L18.7904 22.4629C18.7902 22.466 18.7901 22.4675 18.79 22.4675ZM5.5972 22.1133C5.59727 22.1132 5.5995 22.1128 5.60371 22.1124C5.59924 22.1132 5.59714 22.1135 5.5972 22.1133ZM12.7488 1.54931C12.7518 1.5444 12.7533 1.54228 12.7534 1.54244C12.7534 1.54261 12.752 1.54506 12.7488 1.54931Z"
        fill="var(--color-orange-50)"
        stroke="var(--color-orange-50)"
        strokeWidth="1.5"
    />
);
export const STAR_HALF = (
    <>
        <path
            d="M12.4292 17.6061L12.934 17.0514L12.416 16.5799L11.9102 17.0646L12.4292 17.6061ZM12.4292 17.6061L12.9341 17.0514L12.9342 17.0516L12.935 17.0523L12.9383 17.0553L12.9517 17.0675L13.0052 17.1158C13.0522 17.1583 13.1215 17.2208 13.2101 17.3002C13.3873 17.459 13.6414 17.6852 13.9481 17.9544C14.5623 18.4933 15.3846 19.2016 16.222 19.8838C17.0644 20.5701 17.9026 21.2138 18.5536 21.6338C18.5658 21.6416 18.5779 21.6494 18.5899 21.6571C18.5732 21.6067 18.5554 21.5546 18.5365 21.5006C18.2921 20.8001 17.9157 19.9156 17.519 18.9896C17.5018 18.9495 17.4846 18.9094 17.4674 18.8692C17.0926 17.9947 16.706 17.0926 16.4309 16.3368C16.2872 15.9422 16.1655 15.565 16.092 15.2384C16.0553 15.075 16.0268 14.908 16.017 14.7478C16.0077 14.5964 16.0113 14.3996 16.0766 14.2028C16.1419 14.0058 16.2564 13.8463 16.3551 13.7305C16.459 13.6086 16.5814 13.4936 16.7078 13.3871C16.9599 13.1746 17.2796 12.9528 17.6251 12.7313C18.1971 12.3646 18.9028 11.9595 19.6062 11.5558C19.7522 11.472 19.8981 11.3882 20.0427 11.3049C20.9001 10.8107 21.7141 10.3294 22.3169 9.8978C22.5129 9.7574 22.6752 9.63024 22.8036 9.51734C22.7657 9.51218 22.7252 9.50722 22.6821 9.50253C22.0727 9.43626 21.2138 9.44896 20.2654 9.48046C20.0629 9.48719 19.8565 9.49476 19.6492 9.50237C18.9129 9.52939 18.164 9.55688 17.5304 9.54851C17.1235 9.54313 16.7335 9.52298 16.4046 9.472C16.2397 9.44645 16.0718 9.41046 15.9158 9.35659C15.7668 9.30516 15.5809 9.22142 15.4209 9.07404C15.2104 8.88003 15.0409 8.59391 14.9086 8.34125C14.7643 8.06575 14.616 7.73272 14.4674 7.37375C14.2246 6.78726 13.9637 6.08831 13.7029 5.38969C13.645 5.23483 13.5872 5.07999 13.5296 4.92639C13.2074 4.06708 12.8909 3.2447 12.5965 2.60914C12.5636 2.53815 12.5315 2.47056 12.5002 2.40643C12.3918 2.90829 12.2896 3.53635 12.1762 4.23285C12.1458 4.41946 12.1147 4.61099 12.0824 4.80632C11.9145 5.82162 11.718 6.92372 11.449 7.82814C11.3145 8.28006 11.1531 8.71433 10.9508 9.07609C10.7565 9.42385 10.4738 9.79684 10.0526 9.99372C9.71244 10.1527 9.29851 10.2152 8.90521 10.2405C8.49636 10.2668 8.0337 10.2566 7.55388 10.227C6.66715 10.1723 5.65595 10.0467 4.71714 9.93017C4.64214 9.92085 4.56759 9.9116 4.49361 9.90244C3.70565 9.80489 2.99363 9.72027 2.42796 9.68423C2.50353 9.73949 2.5841 9.79676 2.6695 9.85597C3.29706 10.2911 4.10901 10.7789 4.94759 11.2793C4.99232 11.306 5.03713 11.3327 5.082 11.3594C5.86519 11.8266 6.66302 12.3026 7.29453 12.7297C7.62804 12.9553 7.93548 13.1807 8.17829 13.396C8.3897 13.5835 8.66844 13.8607 8.78185 14.2029C8.89738 14.5514 8.83252 14.9451 8.77087 15.2205C8.69973 15.5384 8.5811 15.9024 8.44136 16.2812C8.18433 16.9781 7.82535 17.8056 7.4716 18.6209C7.44041 18.6929 7.40925 18.7647 7.3782 18.8363C6.98883 19.7347 6.61627 20.6055 6.36746 21.3234C6.30103 21.515 6.24584 21.6891 6.20237 21.8444C6.22452 21.831 6.24724 21.8171 6.27054 21.8026C6.90503 21.4084 7.73894 20.759 8.58801 20.0468C9.43004 19.3406 10.2609 18.5949 10.8828 18.0241C11.1933 17.7391 11.4509 17.4986 11.6305 17.3296C11.7203 17.2451 11.7906 17.1785 11.8382 17.1332L11.8924 17.0817L11.906 17.0687L11.9093 17.0655L11.91 17.0648L11.9102 17.0646L12.4292 17.6061ZM18.79 22.49C18.7899 22.49 18.79 22.488 18.7904 22.4842L18.7904 22.4853C18.7902 22.4885 18.7901 22.49 18.79 22.49ZM5.5972 22.1358C5.59727 22.1357 5.5995 22.1353 5.60371 22.1348C5.59924 22.1357 5.59714 22.1359 5.5972 22.1358ZM12.7488 1.57177C12.7518 1.56686 12.7533 1.56474 12.7534 1.56491C12.7534 1.56507 12.752 1.56752 12.7488 1.57177Z"
            stroke="var(--color-orange-50)"
            strokeWidth="1.5"
        />
        <path
            d="M8 18.5C8.8 18.5 12 17.3333 12.5 17L17 17.5C14 15.5 7.70023 16.5 8.50023 16.5C9.30023 16.5 13.6667 15.5 16 15.5L8.50023 13.5L18 12.5"
            stroke="var(--color-orange-50)"
            strokeWidth="1.5"
        />
    </>
);
export const STAR_EMPTY = (
    <path
        d="M12 17.5836L12.5048 17.029L11.9868 16.5574L11.481 17.0422L12 17.5836ZM12 17.5836L12.5049 17.029L12.505 17.0291L12.5058 17.0298L12.5091 17.0328L12.5225 17.045L12.576 17.0934C12.623 17.1359 12.6923 17.1983 12.7809 17.2777C12.9581 17.4365 13.2122 17.6628 13.5189 17.9319C14.1331 18.4709 14.9554 19.1792 15.7928 19.8614C16.6352 20.5476 17.4734 21.1914 18.1244 21.6113C18.1366 21.6192 18.1487 21.627 18.1607 21.6346C18.144 21.5843 18.1262 21.5321 18.1073 21.4781C17.8629 20.7777 17.4865 19.8931 17.0898 18.9671C17.0726 18.927 17.0554 18.8869 17.0382 18.8467C16.6634 17.9723 16.2768 17.0701 16.0017 16.3144C15.858 15.9198 15.7363 15.5425 15.6628 15.216C15.6261 15.0525 15.5976 14.8855 15.5878 14.7253C15.5785 14.5739 15.5821 14.3771 15.6474 14.1804C15.7127 13.9833 15.8272 13.8239 15.9259 13.708C16.0298 13.5861 16.1522 13.4711 16.2786 13.3646C16.5307 13.1521 16.8504 12.9303 17.1959 12.7088C17.7679 12.3421 18.4736 11.9371 19.177 11.5333C19.323 11.4495 19.4689 11.3657 19.6135 11.2824C20.4709 10.7882 21.2849 10.307 21.8877 9.87534C22.0837 9.73494 22.246 9.60778 22.3745 9.49488C22.3365 9.48972 22.296 9.48476 22.2529 9.48007C21.6435 9.4138 20.7846 9.4265 19.8362 9.458C19.6337 9.46472 19.4273 9.4723 19.22 9.47991C18.4837 9.50693 17.7348 9.53442 17.1012 9.52605C16.6943 9.52067 16.3043 9.50052 15.9754 9.44954C15.8105 9.42399 15.6426 9.388 15.4866 9.33413C15.3376 9.28269 15.1517 9.19896 14.9917 9.05158C14.7812 8.85757 14.6117 8.57145 14.4794 8.31878C14.3351 8.04329 14.1868 7.71026 14.0382 7.35129C13.7954 6.7648 13.5345 6.06585 13.2737 5.36723C13.2158 5.21237 13.158 5.05753 13.1004 4.90393C12.7782 4.04462 12.4617 3.22223 12.1673 2.58668C12.1344 2.51569 12.1023 2.4481 12.071 2.38397C11.9626 2.88583 11.8604 3.51389 11.747 4.21039C11.7167 4.397 11.6855 4.58853 11.6532 4.78386C11.4853 5.79915 11.2888 6.90126 11.0198 7.80568C10.8853 8.2576 10.7239 8.69187 10.5216 9.05363C10.3273 9.40139 10.0446 9.77438 9.62339 9.97126C9.28324 10.1302 8.86931 10.1928 8.47601 10.218C8.06716 10.2443 7.6045 10.2341 7.12468 10.2045C6.23795 10.1499 5.22675 10.0243 4.28794 9.90771C4.21294 9.89839 4.13839 9.88914 4.06441 9.87998C3.27645 9.78243 2.56443 9.69781 1.99876 9.66177C2.07433 9.71703 2.1549 9.7743 2.2403 9.83351C2.86786 10.2686 3.67981 10.7564 4.51839 11.2568C4.56312 11.2835 4.60793 11.3102 4.6528 11.337C5.43599 11.8042 6.23382 12.2801 6.86533 12.7072C7.19885 12.9328 7.50629 13.1582 7.74909 13.3735C7.9605 13.561 8.23924 13.8383 8.35265 14.1804C8.46818 14.529 8.40332 14.9226 8.34168 15.1981C8.27053 15.516 8.1519 15.8799 8.01216 16.2588C7.75514 16.9556 7.39615 17.7831 7.04241 18.5985C7.01121 18.6704 6.98005 18.7422 6.949 18.8138C6.55964 19.7122 6.18707 20.583 5.93826 21.3009C5.87183 21.4926 5.81664 21.6666 5.77317 21.8219C5.79532 21.8085 5.81804 21.7946 5.84134 21.7801C6.47583 21.386 7.30974 20.7365 8.15881 20.0244C9.00084 19.3181 9.83168 18.5724 10.4536 18.0017C10.7641 17.7167 11.0217 17.4762 11.2013 17.3071C11.2911 17.2226 11.3614 17.1561 11.409 17.1108L11.4632 17.0592L11.4768 17.0462L11.4801 17.0431L11.4808 17.0423L11.481 17.0422L12 17.5836ZM18.3608 22.4675C18.3607 22.4675 18.3608 22.4655 18.3612 22.4617L18.3612 22.4629C18.361 22.466 18.3609 22.4675 18.3608 22.4675ZM5.168 22.1133C5.16807 22.1132 5.17031 22.1128 5.17451 22.1124C5.17004 22.1132 5.16794 22.1135 5.168 22.1133ZM12.3196 1.54931C12.3226 1.5444 12.3241 1.54228 12.3242 1.54244C12.3242 1.54261 12.3228 1.54506 12.3196 1.54931Z"
        stroke="var(--color-orange-50)"
        strokeWidth="1.5"
    />
);
export const MENU = (
    <>
        <path
            stroke="currentColor"
            strokeLinejoin="bevel"
            strokeWidth="1.5"
            d="M22 7 2 14M22 2 2 9"
        />
        <path
            fill="currentColor"
            d="M2.55 21.983v-3.472l.818-.29v.379l.119-.043c.057-.136.152-.27.284-.4.131-.136.305-.242.52-.319.234-.082.42-.1.562-.051.14.043.248.129.323.256l.119-.042c.075-.175.18-.337.317-.483a1.43 1.43 0 0 1 .58-.352.995.995 0 0 1 .548-.054c.167.029.299.12.396.272.1.146.152.36.152.64v2.282l-.832.294v-2.219c0-.191-.046-.317-.138-.378-.093-.065-.223-.068-.39-.009a.838.838 0 0 0-.442.352 1.111 1.111 0 0 0-.152.6v2.051l-.831.295v-2.22c0-.19-.046-.317-.139-.377-.092-.066-.222-.069-.389-.01a.837.837 0 0 0-.442.353 1.11 1.11 0 0 0-.152.6v2.05l-.831.295ZM10.53 19.255c-.325.115-.613.145-.864.09a.948.948 0 0 1-.58-.418c-.137-.223-.205-.516-.205-.88v-.084a2.529 2.529 0 0 1 .779-1.843c.246-.237.532-.413.858-.528.32-.114.6-.136.838-.066.237.065.422.21.554.434.132.219.198.506.198.86v.302l-2.382.843c.009.235.092.4.25.492.159.094.352.1.581.019.233-.083.405-.197.515-.343.11-.147.193-.295.25-.446l.68.137a3.582 3.582 0 0 1-.27.495c-.115.18-.269.356-.462.527-.194.167-.44.303-.74.41Zm-.798-1.95 1.531-.542c-.017-.195-.094-.328-.23-.402-.133-.074-.306-.073-.522.003a1.148 1.148 0 0 0-.779.94ZM13.706 18.033V14.56l.818-.29v.455l.119-.042c.052-.14.151-.29.297-.448.145-.164.365-.297.66-.402.255-.09.477-.106.666-.047.193.053.343.17.449.352.105.178.158.41.158.7v2.072l-.832.295v-2.002c0-.262-.061-.436-.184-.523-.119-.088-.29-.093-.515-.014-.255.09-.453.252-.594.484-.14.227-.211.501-.211.823v1.764l-.831.295ZM19.825 15.922c-.255.09-.48.109-.673.056a.762.762 0 0 1-.442-.361c-.106-.182-.158-.416-.158-.7v-2.072l.831-.295v2.002c0 .262.06.437.178.525.123.087.297.091.521.012.255-.09.453-.25.594-.477.141-.231.211-.508.211-.83v-1.764l.832-.295v3.472l-.818.29v-.455l-.12.042a1.558 1.558 0 0 1-.296.448c-.145.164-.365.298-.66.402Z"
        />
    </>
);

export const MAP_PIN = (
    <g>
        <path
            d="M3.75 2.48047L20.25 2.48047V13.453L12 23.078L3.75 13.453L3.75 2.48047Z"
            strokeWidth="1.5"
        />
        <circle cx="12" cy="7.73047" r="2.25" strokeWidth="1.5" />
    </g>
);

export const SHOPPING_BASKET = (
    <>
        <path
            stroke="currentColor"
            strokeLinejoin="bevel"
            strokeWidth="1.5"
            d="M14 9 3 5M23 9l-4 11H6L2 9"
        />
        <path stroke="currentColor" strokeWidth="1.5" d="M3 11.5h19" />
    </>
);
export const SHOPPING_BASKET_ADD = (
    <>
        <path
            stroke="var(--color-beige-50)"
            strokeLinejoin="bevel"
            strokeWidth="1.5"
            d="M18.667 12.036 4 6.703M30.667 12.036l-5.334 14.667H8L2.667 12.036"
        />
        <path
            stroke="var(--color-beige-50)"
            strokeWidth="1.5"
            d="M4 15.37h25.333"
        />
        <circle cx="24.667" cy="6.036" r="6" fill="var(--color-beige-40)" />
        <path
            stroke="var(--color-red-50)"
            strokeWidth="1.5"
            d="M24.667 2.703V9.37M28 6.036h-6.667"
        />
    </>
);
export const CHICKEN = (
    <>
        <path
            stroke=""
            strokeMiterlimit="10"
            strokeWidth="1.5"
            d="M4 23v-8.258L9.633 9h5.792L20 13.662l-4.978 5.072V23"
        />
        <path
            stroke=""
            strokeMiterlimit="10"
            strokeWidth="1.5"
            d="M18 16v3.357L15 22M13 13h2M15.03 9 18 6.099l-2.784-2.721-2.357 2.303-2.288-2.226L7.455 6.5l2.5 2.5"
        />
    </>
);
export const PLUS = (
    <>
        <path d="M1 12h22M12 1v22" stroke="currentColor" strokeWidth="1.5" />
    </>
);
export const MINUS = (
    <>
        <path d="M1 12h22" stroke="currentColor" strokeWidth="1.5" />
    </>
);
export const CHEVRON = (
    <>
        <path
            d="m10 1 3.85 11L10 23"
            fill="none"
            stroke="#3E2313"
            strokeWidth="1.5"
            strokeLinejoin="bevel"
        />
    </>
);
export const INFO = (
    <>
        <circle
            cx="12"
            cy="12"
            r="9.25"
            stroke="currentColor"
            strokeWidth="1.5"
        />
        <path d="M12 10v8M12 6v2" stroke="currentColor" strokeWidth="1.5" />
    </>
);
export const TRASHBIN = (
    <>
        <path
            stroke="var(--color-red-50)"
            strokeWidth="1.5"
            d="M5.75 7.822h12.5v13.5H5.75z"
        />
        <path
            fill="var(--color-red-50)"
            d="m11.425 3.35 2.793 1.01.85-2.35L12.273 1z"
        />
        <path
            stroke="var(--color-red-50)"
            strokeLinejoin="bevel"
            strokeWidth="1.5"
            d="m6 1.072 14 5"
        />
        <path
            stroke="var(--color-red-50)"
            strokeWidth="1.5"
            d="M10 10.072v8.5M14 10.072v8.5"
        />
    </>
);
export const LOCK = (
    <>
        <path
            stroke="currentColor"
            strokeWidth="1.5"
            d="M3.75 9.75h16.5v10.5H3.75zM18 9A6 6 0 0 0 6 9M11.75 13v4"
        />
    </>
);
export const PREFERENCES = (
    <>
        <path d="M4 8h10" strokeWidth="1.5" />
        <circle cx="17" cy="8" r="3.25" strokeWidth="1.5" />
        <circle cx="8" cy="16" r="3.25" strokeWidth="1.5" />
        <path d="M11 16h9" strokeWidth="1.5" />
    </>
);
export const WARN = (
    <path
        d="M3.214 21.25 12 3.677l8.787 17.573H3.213ZM12 9v6M12 16.5v2"
        stroke="var(--color-beige-40)"
        strokeWidth="1.5"
    />
);
export const ERROR = (
    <path
        stroke="var(--color-beige-40)"
        strokeWidth="1.5"
        d="M2.75 2.75h18.5v18.5H2.75zM12 6v8.5M12 16v2"
    />
);
export const EYE = (
    <>
        <>
            <path
                d="M22.25 12c0 .906-.842 1.97-2.782 2.853-1.873.85-4.512 1.397-7.468 1.397-2.956 0-5.595-.546-7.468-1.397C2.592 13.97 1.75 12.906 1.75 12c0-.906.842-1.97 2.782-2.853C6.405 8.297 9.044 7.75 12 7.75c2.956 0 5.595.546 7.468 1.397 1.94.882 2.782 1.947 2.782 2.853Z"
                stroke="var(--color-brown-50)"
                strokeWidth="1.5"
            />
            <circle
                cx="12"
                cy="12"
                r="4.25"
                stroke="var(--color-brown-50)"
                strokeWidth="1.5"
            />
        </>
    </>
);
export const CLOSED_EYE = (
    <>
        <path
            d="M22.25 12c0 .906-.842 1.97-2.782 2.853-1.873.85-4.512 1.397-7.468 1.397-2.956 0-5.595-.546-7.468-1.397C2.592 13.97 1.75 12.906 1.75 12c0-.906.842-1.97 2.782-2.853C6.405 8.297 9.044 7.75 12 7.75c2.956 0 5.595.546 7.468 1.397 1.94.882 2.782 1.947 2.782 2.853Z"
            stroke="var(--color-brown-50)"
            strokeWidth="1.5"
        />
        <path
            d="m1 8 23 8"
            stroke="var(--color-brown-50)"
            strokeWidth="1.5"
            strokeLinejoin="bevel"
        />
        <circle
            cx="12"
            cy="12"
            r="4.25"
            stroke="var(--color-brown-50)"
            strokeWidth="1.5"
        />
    </>
);
export const CLOCK = (
    <>
        <svg fill="none" height="24" viewBox="0 0 24 24" width="24">
            <g stroke="currentColor" strokeWidth="1.5">
                <path d="m18 11-8 3" strokeLinejoin="bevel" />
                <circle cx="12" cy="12" r="11.25" />
                <path d="m12 5v10" />
            </g>
        </svg>
    </>
);

export const NETHERLANDS = (
    <>
        <g clipPath="url(#a)">
            <path fill="#21468B" d="M0 0h24v18H0V0Z" />
            <path fill="#fff" d="M0 0h24v12H0V0Z" />
            <path fill="#AE1C28" d="M0 0h24v6H0V0Z" />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h24v18H0z" />
            </clipPath>
        </defs>
    </>
);

export const BELGIUM = (
    <>
        <g fillRule="evenodd" clipPath="url(#a)" clipRule="evenodd">
            <path fill="#000" d="M0 0h7.999v18H0V0Z" />
            <path fill="#FFD90C" d="M7.999 0H16v18H7.999V0Z" />
            <path fill="#F31830" d="M16.002 0H24v18h-7.998V0Z" />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h24v18H0z" />
            </clipPath>
        </defs>
    </>
);
